export type CreateTeamSubmitErrorCode =
  | "name-unavailable"
  | "starter-office-limit-reached"
  | "unknown";

export class CreateTeamSubmitError extends Error {
  readonly code: CreateTeamSubmitErrorCode;
  readonly fieldErrors: Record<string, string>;

  constructor(params: {
    message: string;
    code?: CreateTeamSubmitErrorCode;
    fieldErrors?: Record<string, string>;
  }) {
    super(params.message);

    this.name = "CreateTeamSubmitError";
    this.code = params.code ?? "unknown";
    this.fieldErrors = params.fieldErrors ?? {};
  }
}
